export class MatterUser {
  id: number;
  matter_id: number;
  user_id: number | null;
  matter_user_type_id: number;
  include_in_all_notifications: boolean = false;
  matter_user_type_name: string;
  display_name: string;
  editing: boolean = false;
  deleting: boolean = false;
  is_active: boolean;
}
